import React, { useId } from 'react';
import { ChevronDown } from 'lucide-react';
interface Option {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Option[];
}
export function Select({
  className = '',
  label,
  error,
  options,
  id,
  ...props
}: SelectProps) {
  const selectId = id || useId();
  return <div className="w-full space-y-1.5" data-id="element-1224">
      {label && <label htmlFor={selectId} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-700" data-id="element-1225">
          {label}
        </label>}
      <div className="relative" data-id="element-1226">
        <select id={selectId} className={`flex h-10 w-full appearance-none rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-1227">
          <option value="" disabled data-id="element-1228">
            Select an option
          </option>
          {options.map(option => <option key={option.value} value={option.value} data-id="element-1229">
              {option.label}
            </option>)}
        </select>
        <ChevronDown className="absolute right-3 top-3 h-4 w-4 opacity-50 pointer-events-none" data-id="element-1230" />
      </div>
      {error && <p className="text-xs text-red-500 font-medium" data-id="element-1231">{error}</p>}
    </div>;
}